export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7608.8543ea48.jpg";